export default function hasStatusNaturedQualities(nature) {
  // Only return categories that contain Status-natured qualities
  return ({ qualities }) => category => category.qualities
    .some(id => qualities.find(q => q.id === id).nature === nature);
}
